import React, { memo } from "react";
import "./SyncToast.css";

/**
 * SyncToast — bottom-right mini toast shown only while syncing.
 *
 * Props:
 *   visible    {boolean}
 *   processed  {number}
 *   total      {number}
 *   error      {string|null}
 */
const SyncToast = memo(function SyncToast({
    visible,
    processed,
    skipped = 0,
    total,
    done,
    error,
}) {
    if (!visible) return null;

    // Progress bar advances for both synced and dead-lettered items
    const pct = total > 0 ? Math.round(((processed + skipped) / total) * 100) : 0;
    const label = error
        ? `Sync paused — ${error}`
        : done
          ? skipped > 0
            ? `Synced ${processed}, skipped ${skipped}`
            : `Synced ${processed} feedback`
          : `Syncing ${Math.min(processed + skipped + 1, total)} of ${total} feedback…`;

    return (
        <div className="sync-toast" role="status" aria-live="polite">
            <span className={`sync-toast-icon${error ? "" : " spin"}`}>
                &#x21BB;
            </span>
            <span className="sync-toast-label">{label}</span>
            {!error && (
                <div className="sync-toast-bar">
                    <div
                        className="sync-toast-bar-fill"
                        style={{ width: `${pct}%` }}
                    />
                </div>
            )}
        </div>
    );
});

export default SyncToast;
